// Exports
export default {
	"content": "content_t9o6X",
	"mobile": "mobile_v7E5f",
	"switch": "switch_AMRC6",
	"permissionsHeader": "permissionsHeader_1aFpv",
	"permissionsExplanation": "permissionsExplanation_h78QM",
	"groupTitle": "groupTitle_02Wv8"
};
